import { FloatingFormItem, TagSelect } from '@/components/_common';
import { useChangeWorkOrderItemTag } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { Form, Modal, ModalProps } from 'antd';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';

type Props = Omit<ModalProps, 'onCancel'> & {
  onCancel: VoidFunction;
  itemId?: number;
};

const ChangeStatusItemModal: React.FC<Props> = ({
  onCancel,
  itemId,
  ...props
}) => {
  const [form] = Form.useForm<{ tagId: number }>();
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const changeWorkorderItemTag = useChangeWorkOrderItemTag();

  async function onSubmit() {
    try {
      const values = await form.validateFields();

      if (complement && itemId) {
        await changeWorkorderItemTag.mutateAsync({
          complementId: complement?.id,
          itemId,
          tagId: values.tagId,
        });

        onCancel();
      }
    } catch {}
  }

  return (
    <Modal
      {...props}
      okText="Salvar"
      onOk={onSubmit}
      onCancel={onCancel}
      title="Alterar situação"
      confirmLoading={changeWorkorderItemTag.isLoading}
      destroyOnClose
    >
      <p>
        Selecione uma tag da empresa vinculada ao orçamento para alterar a
        situação do item.
      </p>

      <Form form={form} preserve={false}>
        <FloatingFormItem name="tagId" label="Tag">
          <TagSelect
            style={{ width: '100%' }}
            companyId={workorder?.company.id}
          />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
};

export default ChangeStatusItemModal;
